import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import { useEffect } from "react";
import { DiscoverBreadcrumbs } from "features/discover/DiscoverBreadcrumbs";
import { DiscoverGamesBulkSelectProvider } from "features/datagrid-configs/discoverGames";
import { DiscoverGamesTableV3 } from "features/discover/gamesTable/v2/DiscoverGamesTableV3";
import { isGranted } from "pages/productManagement/functions";
import { Permission, Resource } from "pages/productManagement/types";
import ForbiddenPage from "./errorPages/ForbiddenPage";

export function DiscoverGamesPageV3() {
	useEffect(() => {
		setScrollBehavior();
	}, []);

	// Guard the page before mounting the table: every grid query requires `game_uploads` READ
	// (see DiscoverGamesDynamicDataGridGetController). Without it, the table would fire many
	// requests that all 403, leaving an empty screen and a flood of "Access denied" toasts.
	if (!isGranted(Resource.GAME_UPLOADS, Permission.READ)) {
		return <ForbiddenPage />;
	}

	return (
		<div className="discover-container discover-container--wide">
			<div className="pageHeading">
				<DiscoverBreadcrumbs
					items={[
						{
							label: "Games",
						},
					]}
				/>
			</div>
			<div className="discover-card discover-card--for-table">
				<DiscoverGamesBulkSelectProvider>
					<DiscoverGamesTableV3 />
				</DiscoverGamesBulkSelectProvider>
			</div>
		</div>
	);
}
